import axios from "axios";
export async function getRecipe(id) {
  const response = await axios.post(process.env.VUE_APP_API_URL + "?recipe", {
    cmd: "get",
    id: id
  });
  return response.data || {};
}
export async function deleteRecipe(id) {
  const response = await axios.post(process.env.VUE_APP_API_URL + "?recipe", {
    cmd: "delete",
    id: id
  });
  return response.data || {};
}
export class Recipe {
  constructor(title) {
    this.id = "";
    this.title = title;
    this.calories = null;
    this.recipe = [];
    this.instructions = [];
    this.type = [];
    this.tags = [];
  }
}

export class Ingredient {
  constructor(amount, unit, title) {
    this.id = 0;
    this.amount = amount;
    this.unit = unit;
    this.title = title;
  }
}

export const UnitOptions = [
  { value: "g", text: "Gramm" },
  { value: "ml", text: "Milliliter" },
  { value: "l", text: "Liter" },
  { value: "Stk", text: "Stück" },
  { value: "Kasten", text: "Kasten" },
  { value: "EL", text: "Esslöffel" },
  { value: "TL", text: "Teelöfel" },
  { value: "Pkg", text: "Packung" },
  { value: "kleine", text: "kleine" },
  { value: "mittelgroße", text: "mittelgroße" },
  { value: "große", text: "große" }
];

export const Types = ["V", "M", "F", "A", "N"];
